export default __webpack_public_path__ + "static/media/drparrow.39169a36.svg";